import React from "react";
import Chart from "react-apexcharts";

const SpendOverTimeChart = () => {

    const options = {
        chart: {
            toolbar: {
                show: false
            },
            zoom: {
                enabled: false
            }
        },

        stroke: {
            curve: "smooth",
            width: 4
        },

        colors: ["#2563EB", "#22C55E"],

        markers: {
            size: 5,
            strokeWidth: 2,
            hover: {
                size: 7
            }
        },

        dataLabels: {
            enabled: false
        },

        xaxis: {
            categories: [
                "Dec 23",
                "Jan 24",
                "Feb 24",
                "Mar 24",
                "Apr 24",
                "May 24"
            ],
            labels: {
                style: {
                    fontSize: "13px"
                }
            }
        },
        yaxis: {
            labels: {
                style: {
                    fontSize: "13px"
                }
            }
        },

        // legend: {
        //     position: "top",
        //     horizontalAlign: "left"
        // },

        legend: {
            position: "top",
            horizontalAlign: "left",
            fontSize: "15px",
            itemMargin: {
                horizontal: 15
            }
        },

        // grid: {
        //     borderColor: "#f1f1f1"
        // }
        grid: {
            borderColor: "#E5E7EB",
            strokeDashArray: 4,
            padding: {
                top: 20,
                bottom: 10,
                left: 10,
                right: 10
            }
        },
        tooltip: {
            shared: true,
            intersect: false
        },
        fill: {
            type: "gradient",
            gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.35,
                opacityTo: 0.8,
                stops: [0, 100]
            }
        },

    };

    const series = [

        {
            name: "Spend (₹ Cr)",
            data: [7, 9, 10, 12, 11, 13]
        },

        {
            name: "Savings (₹ Cr)",
            data: [1, 1.5, 2.2, 2.8, 3.2, 4.1]
        }

    ];

    return (

        <Chart
            options={options}
            series={series}
            type="line"
            height={320}
        />

    );

};

export default SpendOverTimeChart;
